import React from 'react';
import get from 'lodash/get';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { formatPrice } from '../../helper';
import { upsellInfo } from './ExpandServices';

const ServicesFieldShow = ({ record }) => {
  const services =
    get(record, 'services') &&
    get(record, 'services').sort((s) => (s.status === 'DELETED' ? 1 : -1));
  if (!services) {
    return <div />;
  }
  return (
    <Table className="myTable" size="small">
      <TableHead>
        <TableRow selected>
          <TableCell />
          <TableCell>Service Name</TableCell>
          <TableCell>Created</TableCell>
          <TableCell>Status</TableCell>
          <TableCell>Upsell Rejection Reason</TableCell>
          <TableCell>Tax Type</TableCell>
          <TableCell>Total Cost</TableCell>
          <TableCell>Service Duration (Hours)</TableCell>
          <TableCell>Labor Charge</TableCell>
          <TableCell>Parts Charge</TableCell>
          <TableCell>Employee Note</TableCell>
          <TableCell>Service Type</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {services &&
          services.map((s) => (
            <TableRow
              className={s.status === 'DELETED' ? 'deleted-service' : ''}
              selected
              key={s.id}
            >
              <TableCell />
              <TableCell>{s.display_name}</TableCell>
              <TableCell>{s.created_at}</TableCell>
              <TableCell>{s.status}</TableCell>
              <TableCell>{s.upsell_rejection_reason}</TableCell>
              <TableCell>{s.tax_type}</TableCell>
              <TableCell>{formatPrice(s.total_cost_dollars)}</TableCell>
              <TableCell>{s.labor_hours}</TableCell>
              <TableCell>{formatPrice(s.labor_cost_dollars)}</TableCell>
              <TableCell>{formatPrice(s.parts_cost_dollars)}</TableCell>
              <TableCell>{s.employee_note}</TableCell>
              <TableCell>{upsellInfo(s.is_upsell, s.upsell_status)}</TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
};
ServicesFieldShow.defaultProps = { addLabel: false };

export default ServicesFieldShow;
